import axios from "axios";
import {apiUrl} from "../../App";

export async function createUserUseCase(variables: any) {
    return await axios.post(`${apiUrl}/admin/users`, [variables], {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
    });
}